"use strict";
// Extensions are the places where things can be extended.
// The name of an extension is defined by the place where it should be defined.
// This means we would have a registration for a particular point, which refers to a component.
// The Extension component and useExtension hook would be used where you want something to appear
// we also have a repeatable extension point (like for tabs)
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extensions = exports.Extension = exports.useExtensions = exports.useFilterExtensions = exports.getOrderedFilteredExtensions = exports.getFilteredExtensions = exports.useExtensionsOptional = exports.getComponentExtension = exports.useComponentExtensions = exports.useSubscribeTopicWithHandler = exports.useSubscribeTopic = exports.useExtension = exports.useComponentExtension = void 0;
//TODO: rename this file to not imply that they're all hooks
const React = __importStar(require("react"));
const extension_context_1 = require("./extension-context");
const error_boundary_1 = require("./error-boundary");
const auth_context_1 = require("./auth-context");
const react_1 = require("react");
const feature_context_1 = require("./feature-context");
// component extensions
const useComponentExtension = (name, allowUnauthorized) => {
    var _a, _b;
    return (_b = (_a = useComponentExtensions(name, allowUnauthorized)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
};
exports.useComponentExtension = useComponentExtension;
function useExtension(name) {
    var _a, _b;
    return (_b = (_a = (0, exports.useExtensions)(name)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
}
exports.useExtension = useExtension;
/** Client side message system that allows a message being sent to a topic to force any components with that topic to re-render. */
function useSubscribeTopic(topic) {
    const { subscribeUpdates } = (0, extension_context_1.useExtensionContext)();
    const [, setForceRefresh] = React.useState(false);
    React.useEffect(() => {
        return subscribeUpdates(topic, () => {
            setForceRefresh(r => !r);
        });
    }, [topic]);
}
exports.useSubscribeTopic = useSubscribeTopic;
function useSubscribeTopicWithHandler(topic, handler) {
    const { subscribeUpdates } = (0, extension_context_1.useExtensionContext)();
    React.useEffect(() => {
        return subscribeUpdates(topic, (event) => {
            handler(event);
        });
    }, [topic]);
}
exports.useSubscribeTopicWithHandler = useSubscribeTopicWithHandler;
function useComponentExtensions(name, allowUnauthorized) {
    useSubscribeTopic((0, extension_context_1.componentExtensionTopic)(name));
    // check the user is authorized
    const { authorized } = (0, auth_context_1.useIdentity)();
    if (!authorized && !allowUnauthorized)
        return [];
    return (0, exports.useExtensions)(`component-${name}`).map(a => a.component);
}
exports.useComponentExtensions = useComponentExtensions;
function getComponentExtension(name) {
    var _a;
    return (_a = (0, extension_context_1.getExtension)(`component-${name}`)) === null || _a === void 0 ? void 0 : _a.component;
}
exports.getComponentExtension = getComponentExtension;
const useExtensionsOptional = (name) => {
    const { getExtensions } = (0, extension_context_1.useExtensionContext)();
    return name ? getExtensions(name) : undefined;
};
exports.useExtensionsOptional = useExtensionsOptional;
/**
 * Function to get the extensions according to their names and categories.
 * @param name the name that the extensions were registered with.
 * @param category an array of categories that the extensions belong to.
 * @param includeUncategorised a boolean for whether the uncategorised extensions should be included i.e: those without a category array.
 * @returns if no categories are specified, the uncategorised extensions will be returned. Otherwise the relevant extensions are returned.
 */
function getFilteredExtensions(name, category, includeUncategorised = true) {
    return (0, extension_context_1.getExtensions)(name).filter(e => {
        if (!e.category)
            return includeUncategorised;
        return category.some(c => e.category.includes(c));
    });
}
exports.getFilteredExtensions = getFilteredExtensions;
/**
 * Function that retrieves the extensions appropriate to a category, and applies an order to them.
 * @param name the extension name
 * @param category the category to which the extension belongs eg 'email'
 * @param includeUncategorised a boolean that when true will return the uncategorised extensions (defaults to true)
 * @param defaultOrder number that will be used for sorting extensions that don't have an order defined; allowing you to position them at the end by default, or at the start by passing 0 to it (defaults to end-positioning)
 * @returns an array of extensions that are sorted according to the specified or default conditions
 */
function getOrderedFilteredExtensions(name, category, includeUncategorised = true, defaultOrder = 999999) {
    return getFilteredExtensions(name, category, includeUncategorised).sort((a, b) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : defaultOrder) - ((_b = b.order) !== null && _b !== void 0 ? _b : defaultOrder); });
}
exports.getOrderedFilteredExtensions = getOrderedFilteredExtensions;
/** type guard for feature required flags array */
function hasFeatureFlags(x) {
    if (Array.isArray(x === null || x === void 0 ? void 0 : x.requireFlags))
        return true;
    return false;
}
const useFilterExtensions = (extensions) => {
    const flags = (0, feature_context_1.useAccessFlags)();
    // the extensions dependency will have an identical identity, so we use the extensions length to determine whether we need to re-calculate the result
    // flags should have static identity once set also
    const availableExtensions = extensions.length;
    return React.useMemo(() => extensions.filter(f => {
        if (hasFeatureFlags(f)) {
            // By default, in local dev mode we disregard permissions in terms of the activation
            // of routes / extension points for local dev convenience. If you actually need to 
            // test the permission system in this context, comment out the last line and uncomment
            // the line below
            //return f.requireFlags.every(rf => flags.has(rf));
            return __DEV__ || f.requireFlags.every(rf => flags.has(rf));
        }
        return true;
    }), [extensions, availableExtensions, flags]);
};
exports.useFilterExtensions = useFilterExtensions;
const useExtensions = (name) => {
    const { getExtensions } = (0, extension_context_1.useExtensionContext)();
    useSubscribeTopic((0, extension_context_1.extensionTopic)(name));
    return (0, exports.useFilterExtensions)(getExtensions(name));
};
exports.useExtensions = useExtensions;
function hashCode(str) {
    // java String#hashCode
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}
function intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
}
// export const useCompExt = useComponentExtensions;
/** The placeholder / extension component that exposes pluggable functionality to the system. This is designed to have a single extension loaded in here
 * with the children being the fallback content
 */
function Extension({ name, props, children, anonymous }) {
    const ExtensionComponent = (0, exports.useComponentExtension)(name, anonymous);
    if (ExtensionComponent) {
        return (React.createElement(error_boundary_1.ErrorBoundary, null,
            React.createElement(react_1.Suspense, { fallback: React.createElement(React.Fragment, null) },
                React.createElement(ExtensionComponent, Object.assign({}, props)))));
    }
    if (children)
        return React.createElement(React.Fragment, null, children);
    return null;
}
exports.Extension = Extension;
function Extensions({ name, props }) {
    const components = useComponentExtensions(name);
    return (React.createElement(React.Fragment, null, components.map((ExtensionComponent, i) => (React.createElement(error_boundary_1.ErrorBoundary, { key: i },
        React.createElement(ExtensionComponent, Object.assign({}, props)))))));
}
exports.Extensions = Extensions;
// interface IProfileTabExtProps {
//     id: number
// }
// exmple usage
// const X = ({ id }: any) => <div><Extension<IProfileTabExtProps> name="person.profiletab" props={{ id }}>This is the fallback</Extension></div>
